import React from "react";

export default function Star(props) {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill={props.picked ? "#FFBC0D" : "none"}
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M11.5283 2.49358L13.085 5.60695C13.2973 6.04034 13.8633 6.45605 14.341 6.53565L17.1625 7.00443C18.9668 7.30515 19.3913 8.61415 18.0912 9.90549L15.8976 12.099C15.5262 12.4705 15.3227 13.1869 15.4377 13.6999L16.0657 16.4153C16.561 18.5645 15.42 19.396 13.5184 18.2727L10.8738 16.7071C10.3962 16.4241 9.60899 16.4241 9.12253 16.7071L6.47792 18.2727C4.58514 19.396 3.43531 18.5557 3.93062 16.4153L4.5586 13.6999C4.67358 13.1869 4.47015 12.4705 4.09867 12.099L1.90516 9.90549C0.61382 8.61415 1.02953 7.30515 2.83386 7.00443L5.65536 6.53565C6.12413 6.45605 6.6902 6.04034 6.90247 5.60695L8.45917 2.49358C9.30827 0.804223 10.6881 0.804223 11.5283 2.49358Z"
				stroke="#0D0D0D"
				stroke-width={props.hovered ? "2.5" : "1.75"}
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
}
